import React from 'react';
import PropTypes from 'prop-types';

import { i18n } from '@ecster/i18n';
import {
    ButtonGroup,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogCloseButton,
    LabelValue,
    Button,
} from '@ecster/components';

import { formatAmount } from '@ecster/util';

export const PaymentDialog = ({ account, isOpen, onRequestClose }) => {
    const close = () => {
        onRequestClose(false);
    };

    return (
        <div className="payment-dialog">
            <Dialog maxWidth="532px" open={isOpen} onRequestClose={() => close()}>
                <>
                    <DialogCloseButton onRequestClose={() => close()} />
                    <DialogBody>
                        <h3 className="payment-dialog-header">{i18n('account.overview.payment-dialog.header')}</h3>
                        <p className="mb-4">{i18n('account.overview.payment-dialog.info-text')}</p>
                        <LabelValue
                            label={i18n('account.overview.payment-dialog.account-label')}
                            value={account.accountNumber}
                        />
                        <LabelValue
                            label={i18n('account.overview.payment-dialog.balance-label')}
                            value={formatAmount(-1 * account.used)}
                        />
                    </DialogBody>
                    <DialogFooter>
                        <ButtonGroup alignCenter>
                            <Button round onClick={() => close()}>
                                {i18n('account.overview.payment-dialog.link-text')}
                            </Button>
                        </ButtonGroup>
                    </DialogFooter>
                </>
            </Dialog>
        </div>
    );
};

PaymentDialog.propTypes = {
    account: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
};
